import Vue from 'vue';
import { vuetifyColorsToRGB } from '../utils/vuetifyColorsToRGB';
export default Vue.extend({
    name: 'ChannelVideoTag',
    // inheritAttrs: false,
    props: {
        label: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        closable: {
            type: Boolean,
        },
    },
    data() {
        return {};
    },
    computed: {
        adaptedColor() {
            const { color } = this;
            return vuetifyColorsToRGB(color) ?? color;
        },
    },
    watch: {},
    methods: {},
    components: {},
});
